<template>
  <div>
    <navbar :hasSearch="true" />
    <div id="content">
      <div class="row">
        <div class="col-md-6 pb-3">
          <div class="card h-100">
            <ol class="breadcrumb lighten-4 my-auto">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'landingPage' }">
                  <a class="black-text" href="#">Home</a>
                </router-link>
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
              <li class="breadcrumb-item active font-weight-bold">
                Payment Generation
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
            </ol>
          </div>
        </div>
        <quick-links></quick-links>
      </div>
      <div class="content_body">
        <div class="container-fluid no-pad">
          <div id="billRun">
            <!-- <div class="container-fluid no-pad">
                    <div class="d-flex p-1 mb-3 bg-white brs border border-light rounded">
                        <div class="p-2">
                            <h3 class="pl-1">Bill Runs</h3>
                        </div>
                    </div>
            </div>-->
            <div class="container-fluid no-pad">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="border border-light rounded">
                        <!-- Refine start -->
                        <form @submit.prevent="submit">
                          <div class="col-sm-12 bg-white brs">
                            <div class="row"></div>
                            <div class="row mt-2">
                              <div class="col-md-6 col-xl-4">
                                <h4 class="d-inline">Start a Payment Run</h4>
                                <b-btn
                                  no-body
                                  bg-variant="transparent"
                                  class="btn-hc-nb"
                                  v-b-popover.click.hover="'It creates payment records for invoices that are due for collection'"
                                  title="What is payment generation?"
                                >
                                  <i class="fa fa-question-circle y" aria-hidden="true"></i>
                                </b-btn>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <!-- <div class="col-sm-6 col-md-4 col-lg-3 mb-2 mb-2">
                                <span class="d-block">Payments due by:</span>
                                <el-date-picker
                                  class="pr-4"
                                  v-model="pickerDate"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  type="date"
                                  placeholder="Select a date"
                                  required
                                ></el-date-picker>
                              </div> -->
                              <div class="col-sm-6 col-md-4 mb-2 mb-2">
                                <span class="d-block">Collection Method:</span>
                                <b-form-select v-model="selected" class="mb-3" required>
                                  <option :value="null">Please select an option</option>
                                  <option value="DDVAR">Variable</option>
                                  <option value="DDFIX">Fixed</option>
                                </b-form-select>
                              </div>
                              <div class="col-md-4 pb-3">
                                <div class="d-flex h-100">
                                  <div class="align-self-end">
                                    <button
                                      href="#"
                                      class="btn btn-hc mb-0 float-right mb-2"
                                      role="button"
                                      @click="submit()"
                                      :disabled="submitStatus == 'PENDING'"
                                    >
                                      Start
                                      Payment Run
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <!-- Refine end -->
                      <div class="border border-light rounded bg-white brs my-3 pl-3 pr-3">
                        <div class="row mt-3 mb-3">
                          <div class="col-md-6 col-xl-4">
                            <h4>Payment Runs</h4>
                          </div>
                          <div class="col-md-6 col-xl-4">
                            <div class="search_75 text-fade">
                              <form class="input-group md-form form-sm">
                                <input
                                  class="form-control form-control-sm search"
                                  name="search"
                                  placeholder="Search"
                                  autocomplete="off"
                                  type="text"
                                />
                                <div class="input-group-btn">
                                  <a href="#" role="button">
                                    <i class="fa fa-search active" aria-hidden="true"></i>
                                  </a>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div class="table-responsive-lg" v-if="paymentRuns">
                          <b-table
                            id="payment_run_table"
                            striped
                            :items="paymentRuns"
                            :fields="paymentRunFields"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :busy="paymentRuns.length===0"
                          >
                            <template v-slot:table-busy>
                              <b-row align-h="center">
                                <propagate-loader class="mb-3" :color="primaryColour" :size="16"></propagate-loader>
                              </b-row>
                            </template>
                            <template slot="Id" slot-scope="data">
                              <span
                                class="d-inline p-2 fwfont pointer"
                                v-clipboard:copy="data.item.Id"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError"
                              >{{guidShortener(data.item.Id)}}</span>
                            </template>
                            <template
                              slot="RunCreated"
                              slot-scope="data"
                            >{{data.item.RunCreated | moment('DD.MM.YY HH:mm')}}</template>
                            <template
                              slot="RunCompleted"
                              slot-scope="data"
                            >{{data.item.RunCompleted | moment('DD.MM.YY HH:mm')}}</template>
                            <template slot="Status" slot-scope="data">
                              {{wordSplit(data.item.Status)}}
                              <!-- <p v-if="data.item.Status === 0">In Progress</p>
                                                    <p v-else-if="data.item.Status === 1">Failed</p>
                              <p v-else-if="data.item.Status === 2">Successful</p>-->
                            </template>
                            <template slot="payments" slot-scope="data">
                              <a
                                href="#"
                                class="bb"
                                data-toggle="modal"
                                data-target="#Payments"
                                @click="rowPaymentsClicked(data.item)"
                              >View</a>
                            </template>
                            <template slot="logs" slot-scope="data">
                              <!-- This takes you to logs modal -->
                              <a
                                href="#"
                                class="bb"
                                data-toggle="modal"
                                data-target="#PaymentRunLogs"
                                @click="rowLogsClicked(data.item)"
                              >View</a>
                            </template>
                          </b-table>
                          <payments></payments>
                          <payment-run-logs></payment-run-logs>
                        </div>
                        <hr />
                        <!-- ####################################################################################### -->
                        <div class="container-fluid no-pad" v-if="paymentRuns.length!==0">
                          <div class="d-flex overflow-auto my-3">
                            <b-pagination
                              class="my-auto d-flex justify-content-center align-items-center mx-auto"
                              v-model="currentPage"
                              :total-rows="paymentRuns.length"
                              :per-page="perPage"
                              aria-controls="payment_run_table"
                              @input="scrollToTop()"
                            >
                              <template v-slot:first-text>
                                <i class="fas fa-angle-double-left fa-2x pointer"></i>
                              </template>
                              <template v-slot:prev-text>
                                <i class="fas fa-chevron-left fa-2x pointer"></i>
                              </template>
                              <template v-slot:next-text>
                                <i class="fas fa-chevron-right fa-2x pointer"></i>
                              </template>
                              <template v-slot:last-text>
                                <i class="fas fa-angle-double-right fa-2x pointer"></i>
                              </template>
                            </b-pagination>
                          </div>
                        </div>
                        <!-- ####################################################################################### -->
                        <!-- <div class="container-fluid no-pad">
                          <div class="d-flex my-3">
                            <ul
                              class="pagination my-auto list-inline d-flex justify-content-center align-items-center mx-auto"
                            >
                              <li class="page-item">
                                <a class="page-link" href="#">
                                  <i class="fa fa-chevron-left fa-2x" aria-hidden="true"></i>
                                </a>
                              </li>
                              <li class="page-item active">
                                <a class="page-link" href="#">1</a>
                              </li>
                              <li class="page-item">
                                <a class="page-link" href="#">2</a>
                              </li>
                              <li class="page-item">
                                <a class="page-link" href="#">3</a>
                              </li>
                              <li class="page-item">
                                <a class="page-link" href="#">
                                  <i class="fa fa-chevron-right fa-2x" aria-hidden="true"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>-->
                        <!-- ####################################################################################### -->
                      </div>
                    </div>
                    <!-- 12 col close -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- content close -->
</template>
<script>
import Vue from 'vue';
import QuickLinks from '@/components/QuickLinks.vue';
import Payments from '@/components/modals/Payments.vue';
import PaymentRunLogs from '@/components/modals/PaymentRunLogs.vue';

import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import Navbar from '@/components/Navbar.vue';

export default {
	components: {
		Navbar,
		QuickLinks,
		PaymentRunLogs,
		Payments,
	},
	data() {
		return {
			perPage: 10,
			currentPage: 1,
			submitStatus: null,
			pickerDate: moment().format('YYYY-MM-DD'),
			selected: null,
			selections: [],
			paymentRunFields: {
				Id: {
					key: 'Id',
					label: 'Payment Run Number',
					sortable: true,
					class: 'text-center',
				},
				// AccountNumber: {
				//   lable: "Account Number",
				//   class: "text-center"
				// },
				started: {
					key: 'RunCreated',
					label: 'Run Created',
					class: 'text-center',
				},
				end: {
					key: 'RunCompleted',
					label: 'Run Completed',
					class: 'text-center',
				},
				status: {
					key: 'Status',
					label: 'Status',
					class: 'text-center',
				},
				Quantity: {
					lable: 'Quantity',
					class: 'text-center',
				},
				payments: {
					label: 'Payments',
					class: 'text-center',
				},
				logs: {
					label: 'Logs',
					class: 'text-center',
				},
			},
		};
	},
	validations: {
		date: {
			required,
		},
		selected: {
			required,
		},
	},
	computed: {
		primaryColour() {
			return Vue.config.honeycomb.theme;
		},
		accessToken() {
			return this.$auth.accessToken;
		},
		xsrfToken() {
			return this.$auth.xsrfToken;
		},
		moneybot() {
			return Vue.config.honeycomb.moneybot.domain;
		},
		paymentRuns() {
			return this.$_.sortBy(
				this.$store.state.finances.paymentRuns,
				'RunCreated'
			).reverse();
		},
		results() {
			return this.$store.state.results;
		},
		date() {
			return moment.utc(this.pickerDate).format();
		},
	},
	methods: {
		scrollToTop() {
			document.getElementById('payment_run_table').scrollIntoView();
		},
		guidShortener: function(guid) {
			var foo = guid.slice(0, 8);
			return foo;
		},
		createSelections() {
			// Clear selections array to prevent pushing additional collection methods if the page is not refreshed
      this.selections.length = 0;
      this.selections.push(this.selected);
			return this.selections;
		},
		rowPaymentsClicked(item) {
			this.$store.commit('updatePayments', null);
			this.$store.dispatch('getPayments', item);
		},
		rowLogsClicked(item) {
			this.$store.commit('updatePaymentLogs', null);
			this.$store.dispatch('getPaymentLogs', item);
		},
		onCopy(e, elementId) {
			this.$snotify.success(`${e.text} copied to clipboard.`);
			document.getElementById(elementId).click();
		},
		onError() {
			this.$snotify.error(`Failed to copy text to clipboard.`, {
				timeout: 0,
				closeOnClick: true,
			});
		},
		submit() {
			if (this.pickerDate == '' || !this.pickerDate) {
				this.$snotify.warning(`Please provide a payment due date.`);
				return false;
			}
			if (this.selected == '' || !this.selected) {
				this.$snotify.warning(`Please select a collection method.`);
				return false;
			}
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.submitStatus = 'ERROR';
			} else {
				// do your submit logic here
				this.submitStatus = 'PENDING';
				setTimeout(() => {
					this.$http
						.post(
							'https://' +
								Vue.config.honeycomb.ddbot.domain +
								'/api/v1/PaymentGenerationRuns',
							{
								CollectionMethods: this.createSelections(),
							},
							{
								withCredentials: true,
							}
						)
						.then(() => {
							this.submitStatus = 'OK';
							this.$snotify.success(`Success! Payment run created.`);
							this.$store.dispatch('getPaymentRuns');
						})
						.catch((error) => {
							// Error
							if (error.response) {
								// The request was made and the server responded with a status code
								// that falls out of the range of 2xx
								this.submitStatus = 'Error';
								if (error.response.data.MoreInformation.length > 0) {
									error.response.data.MoreInformation.forEach((e) => {
										this.$snotify.error(`${e.Error}`, {
											timeout: 0,
											closeOnClick: true,
										});
									});
								} else {
									this.$snotify.error(
										`${error.response.data.UserDescription}`,
										{
											timeout: 0,
											closeOnClick: true,
										}
									);
								}
							} else if (error.request) {
								// The request was made but no response was received
								// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
								// http.ClientRequest in node.js
								this.submitStatus = 'Error';
								this.$snotify.error(`No response recieved.`, {
									timeout: 0,
									closeOnClick: true,
								});
							} else {
								// Something happened in setting up the request that triggered an Error
								this.submitStatus = 'Error';
								this.$snotify.error(`${error.message}`, {
									timeout: 0,
									closeOnClick: true,
								});
							}
						});
				}, 1200);
			}
		},
	},
	created() {
		this.$store.dispatch('getPaymentRuns');
	},
};
</script>
